import { fillValues } from '@utils';

// Source: https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const padWithZero = (v: string) => {
  if (Number(v) < 10){
    return "0" + v
  }
  return v
}

export const formatMillisecondsToReadable = (time: number, str: string) => {
  const num = parseInt(String(time), 10)
  const hours   = padWithZero(String(Math.floor(num / 3600)))
  const minutes =  padWithZero(String(Math.floor((num - (Number(hours) * 3600)) / 60)))
  return fillValues(str, {
    hours,
    minutes
  });
}

export class Milliseconds {
  ms: number
  constructor(milliseconds?: number) {
    this.ms = milliseconds
  }
  
  toHours = () => {
    return this.toMinutes() / 60
  }
  
  toMinutes = () => {
    return this.toSeconds() / 60
  }
  
  toSeconds = () => {
    return this.ms / 1000
  }
  
  fromHours = (nb: number) => {
    return nb * (3600 * 1000)
  }
  
  fromDays = (nb: number) => {
    return this.fromHours(24) * nb
  }
  
}